import { ReactElement } from 'react';
import './AmountButton.styles.css';

interface AmountButtonProps {
    onClick: () => void;
    actionType?: 'increase' | 'decrease';
    text?: string;
    title?: string;
    className?: string;
}

export const AmountButton = ({
    text,
    actionType = 'increase',
    onClick,
    title,
}: AmountButtonProps): ReactElement | null => {
    return (
        <button type="button" className="amountButton" onClick={onClick} title={title ?? undefined}>
            <div className={`icon${actionType === 'increase' ? ' increase' : ' decrease'}`} />
            {text && <span className="text">{text}</span>}
        </button>
    );
};
